<div class="map-button-group">
  <dv-button
    class="map-button-group__item"
    size="md"
    [isSelectedStateActive]="true"
    color="secondary"
    icon="layers_triple"
    [tooltip]="(isAerialMapOn ? 'Map.TurnOnVectorMap' : 'Map.TurnOnAerialMap') | translate"
    tooltipPosition="left"
    (click)="toggleMapView()"
  ></dv-button>
  <dv-button
    class="map-button-group__item"
    size="md"
    color="secondary"
    icon="my_location"
    [tooltip]="'Map.MyPosition' | translate"
    tooltipPosition="left"
    (click)="focusMyLocation()"
  ></dv-button>
  <div class="map-button-group__item map-button-group__item--with-dot">
    <dv-button
      size="md"
      icon="menu"
      color="secondary"
      [tooltip]="'Map.Legend.RouteColorLegend' | translate"
      tooltipPosition="left"
      (click)="showLegend()"
    ></dv-button>
    @if (hasHiddenPoiTypes()) {
      <dv-badge-dot class="map-button-group__dot" type="informative" aria-hidden="true" />
    }
  </div>
  <dv-button
    class="map-button-group__item"
    size="md"
    icon="language"
    color="secondary"
    [tooltip]="'General.Language' | translate"
    tooltipPosition="left"
    (click)="changeLanguage()"
  ></dv-button>
  <dv-button
    class="map-button-group__item"
    size="md"
    icon="info_filled"
    color="secondary"
    [tooltip]="'Map.Info' | translate"
    tooltipPosition="left"
    (click)="navigateToInfo()"
  >
  </dv-button>
</div>
